function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import MedicationRequest from "core/models/prescriptions/medication-request";
export class Dose {
  constructor(opts) {
    _defineProperty(this, "quantity", void 0);
    _defineProperty(this, "unit", void 0);
    _defineProperty(this, "period", void 0);
    this.quantity = +opts.quantity;
    this.unit = opts.unit;
    this.period = opts.period;
  }
  isEqual(dose) {
    return this.quantity === dose?.quantity && this.unit === dose?.unit && this.period === dose?.period;
  }
}
/**
 * Grouped a list of MedicationRequest by ATC code
 * and compute the total dosage for each group if the dosage is the same for a given ATC code.
 */
export default function medicationRequestGroupByAtc(medicationRequests) {
  const map = new Map();
  medicationRequests.forEach(medicationRequest => {
    const key = medicationRequest.medication?.molecule?.code || medicationRequest.medication?.name;
    if (!key) return;
    const existingGroup = map.get(key);
    let doseDisplayed;
    if (medicationRequest.dosePerTimingUnit) {
      doseDisplayed = new Dose({
        quantity: medicationRequest.dosePerTimingUnit,
        unit: medicationRequest.medication?.unit,
        period: medicationRequest.dosage?.timing?.periodUnit
      });
    }
    let comment = "";

    //if two medications have the same molecule and the same timing
    //the dosage is the sum of them
    //else it cannot be computed.

    if (existingGroup) {
      if (doseDisplayed &&
      // If doseDisplayed is set, the medicationRequest has a dosage
      existingGroup.medicationRequest.dosage?.isEqual(medicationRequest.dosage)) {
        if (existingGroup.doseDisplayed != undefined) {
          doseDisplayed.quantity += existingGroup.doseDisplayed.quantity;
        }
      } else {
        doseDisplayed = undefined;
      }
      comment = existingGroup.comment || "";
    }

    // Concatenate comments of all same ATC code
    comment += medicationRequest.comment ? " " + medicationRequest.comment : "";
    map.set(key, {
      medicationRequest,
      doseDisplayed,
      comment
    });
  });
  return map;
}